import { useEffect } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { trackPageView } from "@/lib/analytics";

export const ScrollToTop = () => {
  const { pathname, search, state } = useLocation();
  const keepScroll = !!(state as { keepScroll?: boolean } | null)?.keepScroll;
  const navType = useNavigationType();
  const navigate = useNavigate();

  // Back from Google/Apple sign-in: the provider returns to the site root,
  // so send the reader on to where the sign-in started (e.g. a letter).
  useEffect(() => {
    let target: string | null = null;
    try { target = sessionStorage.getItem("ld_after_login"); } catch { /* storage off */ }
    if (!target || !/^\/(?!\/)/.test(target)) return;
    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) return;
      try { sessionStorage.removeItem("ld_after_login"); } catch { /* storage off */ }
      navigate(target as string, { replace: true });
    });
  }, [pathname, navigate]);

  useEffect(() => {
    if (navType !== "POP" && !keepScroll) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
    // Defer so route's <Helmet> can update document.title first
    const t = window.setTimeout(() => trackPageView(pathname + search), 50);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search, navType]);

  return null;
};
